module.exports = __webpack_public_path__ + "img/377w.4ed1d0e.jpg";